import { SearchIcon } from "lucide-react";

import { NavList, NavListItem } from "@/components/ui/nav-list";
import { Text } from "@/components/ui/text";
import { useSearchHistory, useSearchQuery } from "../store";

export function RecentSearches() {
  const [, setQueryStr] = useSearchQuery();
  const history = useSearchHistory();

  const handlePress = (str: string) => {
    return (
      e: React.MouseEvent<HTMLDivElement> | React.KeyboardEvent<HTMLDivElement>,
    ) => {
      if ("key" in e) {
        if (e.key === "Enter") {
          e.preventDefault();
          setQueryStr(str);
        }
        return;
      }
      setQueryStr(str);
    };
  };

  return (
    <div className="flex flex-col p-5">
      <Text muted size="2" className="px-3">
        Recent searches
      </Text>
      <div>
        <NavList
          items={history.map((str) => ({ str }))}
          autoFocus
          aria-label="Recent searches"
          className="border-b-0"
        >
          {(item) => (
            <NavListItem key={item.str} asChild>
              <div
                className="flex items-center gap-2 px-3 py-2 cursor-pointer"
                onClick={handlePress(item.str)}
                onKeyDown={handlePress(item.str)}
              >
                <Text size="3" muted className="flex items-center gap-2">
                  <SearchIcon className="size-4" /> {item.str}
                </Text>
              </div>
            </NavListItem>
          )}
        </NavList>
      </div>
    </div>
  );
}
